import React, { FC } from 'react';

import { Typography } from '@material-ui/core';
import Translation from '../../../../../../gqlCommon/components/translation/Translation';
import usePlatformConfig from '../../../../../../common/react/usePlatformConfig';
import SelectedFeaturesContainerComplex from '../../complexBrands/summary/summaryAdditionalSelections/selectedFeatures/SelectedFeaturesContainer';
import SelectedFeaturesContainer from '../../simpleBrands/summary/summaryAdditionalSelections/selectedFeatures/SelectedFeaturesContainer';
import summaryAdditionalSelectionsStyles from './summaryAdditionalSelectionsStyles';

const SummaryAdditionalSelectionsContainer: FC = () => {
  const styles = summaryAdditionalSelectionsStyles();
  const {
    platformConfig: { isComplexModel },
  } = usePlatformConfig();

  return (
    <>
      <Typography className={styles.title} variant="subtitle1">
        <Translation id={'trans__configurator__customise_page_summary_section__selections_title'} />
      </Typography>
      {isComplexModel ? <SelectedFeaturesContainerComplex /> : <SelectedFeaturesContainer />}
    </>
  );
};

export default SummaryAdditionalSelectionsContainer;
